// This file is auto-generated by scripts/regen-bestiary.mjs. Do not edit manually.

import { ISpritesheetData } from 'pixi.js';

export interface ISpritesheetMetadata {
  name: string;
  metadata: ISpritesheetData;
}

export const JinnSpritesheets: ISpritesheetMetadata[] = [
  {
    name: 'jinn-attack',
    metadata: {
      frames: {
        'jinn-attack-0': {
          frame: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'jinn-attack-1': {
          frame: {
            x: 128,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'jinn-attack-2': {
          frame: {
            x: 256,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'jinn-attack-3': {
          frame: {
            x: 384,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
      },
      meta: {
        image: '/sprites/entities/jinn/attack.png',
        size: {
          w: 512,
          h: 128,
        },
        scale: '1',
      },
      animations: {
        'jinn-attack': [
          'jinn-attack-0',
          'jinn-attack-1',
          'jinn-attack-2',
          'jinn-attack-3',
        ],
      },
    },
  },
  {
    name: 'jinn-die',
    metadata: {
      frames: {
        'jinn-die-0': {
          frame: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'jinn-die-1': {
          frame: {
            x: 128,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'jinn-die-2': {
          frame: {
            x: 256,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'jinn-die-3': {
          frame: {
            x: 384,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'jinn-die-4': {
          frame: {
            x: 512,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'jinn-die-5': {
          frame: {
            x: 640,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
      },
      meta: {
        image: '/sprites/entities/jinn/die.png',
        size: {
          w: 768,
          h: 128,
        },
        scale: '1',
      },
      animations: {
        'jinn-die': [
          'jinn-die-0',
          'jinn-die-1',
          'jinn-die-2',
          'jinn-die-3',
          'jinn-die-4',
          'jinn-die-5',
        ],
      },
    },
  },
  {
    name: 'jinn-run',
    metadata: {
      frames: {
        'jinn-run-0': {
          frame: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'jinn-run-1': {
          frame: {
            x: 128,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'jinn-run-2': {
          frame: {
            x: 256,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'jinn-run-3': {
          frame: {
            x: 384,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
      },
      meta: {
        image: '/sprites/entities/jinn/run.png',
        size: {
          w: 512,
          h: 128,
        },
        scale: '1',
      },
      animations: {
        'jinn-run': ['jinn-run-0', 'jinn-run-1', 'jinn-run-2', 'jinn-run-3'],
      },
    },
  },
  {
    name: 'jinn-exhaust',
    metadata: {
      frames: {
        'jinn-exhaust-0': {
          frame: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'jinn-exhaust-1': {
          frame: {
            x: 128,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
      },
      meta: {
        image: '/sprites/entities/jinn/exhaust.png',
        size: {
          w: 256,
          h: 128,
        },
        scale: '1',
      },
      animations: {
        'jinn-exhaust': ['jinn-exhaust-0', 'jinn-exhaust-1'],
      },
    },
  },
  {
    name: 'jinn-idle',
    metadata: {
      frames: {
        'jinn-idle-0': {
          frame: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'jinn-idle-1': {
          frame: {
            x: 128,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'jinn-idle-2': {
          frame: {
            x: 256,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
      },
      meta: {
        image: '/sprites/entities/jinn/idle.png',
        size: {
          w: 384,
          h: 128,
        },
        scale: '1',
      },
      animations: {
        'jinn-idle': ['jinn-idle-0', 'jinn-idle-1', 'jinn-idle-2'],
      },
    },
  },
  {
    name: 'jinn-magicAttack',
    metadata: {
      frames: {
        'jinn-magicAttack-0': {
          frame: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'jinn-magicAttack-1': {
          frame: {
            x: 256,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'jinn-magicAttack-2': {
          frame: {
            x: 512,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'jinn-magicAttack-3': {
          frame: {
            x: 768,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'jinn-magicAttack-4': {
          frame: {
            x: 1024,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'jinn-magicAttack-5': {
          frame: {
            x: 1280,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'jinn-magicAttack-6': {
          frame: {
            x: 1536,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'jinn-magicAttack-7': {
          frame: {
            x: 1792,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'jinn-magicAttack-8': {
          frame: {
            x: 2048,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'jinn-magicAttack-9': {
          frame: {
            x: 2304,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'jinn-magicAttack-10': {
          frame: {
            x: 2560,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'jinn-magicAttack-11': {
          frame: {
            x: 2816,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'jinn-magicAttack-12': {
          frame: {
            x: 3072,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
      },
      meta: {
        image: '/sprites/entities/jinn/magicAttack.png',
        size: {
          w: 3328,
          h: 256,
        },
        scale: '1',
      },
      animations: {
        'jinn-magicAttack': [
          'jinn-magicAttack-0',
          'jinn-magicAttack-1',
          'jinn-magicAttack-2',
          'jinn-magicAttack-3',
          'jinn-magicAttack-4',
          'jinn-magicAttack-5',
          'jinn-magicAttack-6',
          'jinn-magicAttack-7',
          'jinn-magicAttack-8',
          'jinn-magicAttack-9',
          'jinn-magicAttack-10',
          'jinn-magicAttack-11',
          'jinn-magicAttack-12',
        ],
      },
    },
  },
];
